import { AppConfig } from './../../app/app.config';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { TeamManagerService } from './../../services/teammanager.service';
import { AlertService } from './../../providers/alert.service';
import { FormBuilder, Validators } from '@angular/forms';


/*
  充值:deposit
*/
@Component({
    selector: 'deposit',
    templateUrl: 'deposit.html',
    providers: [
        TeamManagerService,
        AlertService
    ]
})
export class Deposit {

    constructor(
        private viewCtrl: ViewController,
        private teammanager: TeamManagerService,
        private alert: AlertService,
        private navpar: NavParams,
        private config: AppConfig,
        private formBuilder: FormBuilder) { }

    //登录的用户信息
    user = this.config.getCurrentUser();
    toUserName = '';

    types = [{ name: '请选择', value: '' }, { name: '代充', value: '0' }, { name: '分红', value: '2' }];

    depositForm = this.formBuilder.group({
        'Type': ['', [Validators.required]],
        'Amount': ['', [Validators.required]],
        'BankPassword': ['', [Validators.required]],
        'ToUserName': this.navpar.data['toUserName']
    });

    ionViewWillEnter() {
        this.toUserName = this.navpar.data['toUserName'];
        if (this.user.HasDailyWages) {
            this.types.push({ name: '日工资', value: '1' });
        }
        // if (this.user.HasDividend) {
        //     this.types.push({ name: '分红', value: '2' });
        // }
    }

    //确认充值
    //tqq 2018-07-16
    doDeposit() {
        this.teammanager.transfer(this.depositForm.value).then(s => {
            if (s.Result) {
                this.alert.showConfirms('转账成功！', () => {
                    this.viewCtrl.dismiss({ 'toUserName': this.depositForm.value['ToUserName'], 'amount': this.depositForm.value['Amount'] });
                });
            } else {
                this.alert.showAlert(s.Error);
            }
        });
    }

    //关闭
    //chen 2017-01-03
    dismiss() {
        this.viewCtrl.dismiss();
    }
}







// WEBPACK FOOTER //
// ./src/pages/teammanager/deposit.ts